import React from 'react'

/**
 * Body shown in the "delete sample(s)" confirmation when some of the samples have attached
 * metadata, explaining the Delete-vs-Unlink choice in terms of the consequence (unlink preserves
 * the metadata so it re-attaches to a re-uploaded, similarly-named sample). Shared by the per-row
 * and batch delete flows so the wording stays in sync.
 */
export const metadataDeleteChoiceMessage = (sampleCount: number, metadataCount: number): React.ReactNode => (
  <>
    <div>
      {sampleCount} {sampleCount === 1 ? 'sample' : 'samples'} will be deleted.
    </div>
    <div>
      {metadataCount} {metadataCount === 1 ? 'sample has' : 'samples have'} attached metadata (primers, names, …).
    </div>
    <div className="mt-2">
      Select whether to delete that metadata too (<b>Delete</b>) or preserve it for re-use with a sample of similar name (<b>Unlink</b>
      ).
    </div>
  </>
)
